import { useState } from "react";
import { ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { mediaUrl } from "@/lib/api";
import { formatBytes } from "@/lib/format";

const MediaView = ({ item }) => {
  const [failed, setFailed] = useState(false);
  const src = mediaUrl(item.id);
  if (failed) {
    return (
      <p className="p-10 text-center text-sm text-slate-300" data-testid="media-preview-error">
        Pratinjau tidak didukung browser ini. Gunakan tombol "Buka / Unduh".
      </p>
    );
  }
  if (item.mime.startsWith("video/")) {
    return <video src={src} controls autoPlay playsInline onError={() => setFailed(true)} className="max-h-[70vh] w-full bg-black" data-testid="media-preview-video" />;
  }
  return <img src={src} alt={item.filename} onError={() => setFailed(true)} className="max-h-[70vh] w-auto max-w-full object-contain" data-testid="media-preview-image" />;
};

const NavButton = ({ side, onClick, testId }) => {
  const Icon = side === "left" ? ChevronLeft : ChevronRight;
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={`absolute top-1/2 ${side === "left" ? "left-3" : "right-3"} flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-white/15 text-white backdrop-blur transition-colors hover:bg-white/30`}
    >
      <Icon className="h-5 w-5" />
    </button>
  );
};

export const MediaPreviewDialog = ({ items, index, onIndexChange, onClose }) => {
  const item = index !== null ? items[index] : null;
  const step = (d) => onIndexChange((index + d + items.length) % items.length);
  return (
    <Dialog open={!!item} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-4xl gap-0 overflow-hidden border-slate-800 bg-slate-950 p-0 text-white [&>button]:text-white" data-testid="media-preview-dialog">
        {item && (
          <>
            <DialogHeader className="space-y-0.5 px-5 pb-4 pt-5 text-left">
              <DialogTitle className="truncate pr-8 text-base font-semibold">{item.filename}</DialogTitle>
              <DialogDescription className="text-slate-400">{formatBytes(item.size)} · Lampiran {index + 1} dari {items.length}</DialogDescription>
            </DialogHeader>
            <div className="relative flex min-h-[280px] items-center justify-center bg-black">
              <MediaView key={item.id} item={item} />
              {items.length > 1 && <NavButton side="left" onClick={() => step(-1)} testId="media-prev-btn" />}
              {items.length > 1 && <NavButton side="right" onClick={() => step(1)} testId="media-next-btn" />}
            </div>
            <div className="flex justify-end px-5 py-4">
              <a href={mediaUrl(item.id)} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-xl bg-white/10 px-4 py-2 text-sm font-medium transition-colors hover:bg-white/20" data-testid="media-open-new-tab">
                <ExternalLink className="h-4 w-4" /> Buka / Unduh
              </a>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
